import { React, useState } from "react";
import Projectlist from "../components/Projectlist";
export default function Projects() {
    const [inputText, setInputText] = useState("");
    let inputHandler = (e) => {
        var lowerCase = e.target.value.toLowerCase();
        setInputText(lowerCase);
    };
    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>
                        Projecten
                        <br></br>
                        Programmeren
                    </h1>
                    <div className="purple-line"></div>

                    <p>Bekijk hier het werk van onze studenten</p>
                </div>
                <img
                    src="./img/project.svg"
                    alt="Grafische element van portfolio"
                />
            </div>
            <div className="search">
                <input
                    type="text"
                    onChange={inputHandler}
                    label="Search"
                    className="search-bar"
                    placeholder="Search.."
                />
            </div>
            <Projectlist input={inputText} />
        </div>
    );
}
